// しるし結び: 商品カードのスワイプ位置に合わせてドットを切り替える
if (!window.smCardSliderLoaded) {
  window.smCardSliderLoaded = true;
  document.addEventListener(
    'scroll',
    (event) => {
      const slider = event.target;
      if (!(slider instanceof Element) || !slider.classList.contains('sm-slider')) return;
      const index = Math.round(slider.scrollLeft / slider.clientWidth);
      const dots = slider.parentElement.querySelectorAll('.sm-dot');
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    },
    true
  );
}
